import {
  UPDATE_CANDIDATE_TECHNICAL_SKILLS_REQUEST,
  UPDATE_CANDIDATE_TECHNICAL_SKILLS_SUCCESS,
  UPDATE_CANDIDATE_TECHNICAL_SKILLS_ERROR,
  RESET_CANDIDATE_TECHNICAL_SKILLS_MESSAGE,
} from "../../actionTypes";

// action creators
export const updateCandidateTechnicalSkillsRequest = (data) => ({
  type: UPDATE_CANDIDATE_TECHNICAL_SKILLS_REQUEST,
  payload: data,
});

export const updateCandidateTechnicalSkillsSuccess = (message) => ({
  type: UPDATE_CANDIDATE_TECHNICAL_SKILLS_SUCCESS,
  payload: message,
});

export const updateCandidateTechnicalSkillsError = (error) => ({
  type: UPDATE_CANDIDATE_TECHNICAL_SKILLS_ERROR,
  payload: error,
});

export const resetCandidateTechnicalSkillsMessage = () => ({
  type: RESET_CANDIDATE_TECHNICAL_SKILLS_MESSAGE,
});
